<template lang="pug">
section.relatorio-rastreabilidade
    BaseHeader(
        :titulo='$t("mensagens.relatorioRastreabilidade.titulo")',
        :btnTexto="$t('mensagens.relatorioRastreabilidade.novoCadastro')",
        :exibeBotao='true',
        icon='el-icon-plus',
        @btnHeaderClicado='cadastrarNovoRelatorio'
        )
    .view-container-base-header
        .relatorio-rastreabilidade-container
            FiltrarRelatorioRastreabilidade(isLoading=false)
            h3 {{ $t('mensagens.relatorioRastreabilidade.tabelaListagem.titulo') }}
            .el-card
                .view-table
                    ListagemRelatorioRastreabilidade

</template>
<script>
import BaseHeader from '@/components/BaseHeader.vue';
import FiltrarRelatorioRastreabilidade from '@/components/relatorioRastreabilidade/FiltrarRelatorioRastreabilidade.vue';
import ListagemRelatorioRastreabilidade from '@/components/relatorioRastreabilidade/ListagemRelatorioRastreabilidade.vue';
export default {
    name: 'RelatorioRastreabilidade',
    components: {
        BaseHeader,
        FiltrarRelatorioRastreabilidade,
        ListagemRelatorioRastreabilidade
    },
    data() {
        return {
            
        };
    },
    methods: {
        cadastrarNovoRelatorio() {
            this.$router.push({ name: 'relatorio-rastreabilidade-cadastro' });
        }
    }
};
</script>
<style lang="scss" scoped>
.relatorio-rastreabilidade {
    .view-container-base-header {
        overflow-y: auto;

        .relatorio-rastreabilidade-container {
            .el-button--default:focus {
                border-color: var(--secondary-two);
                color: var(--white) !important;
                background: var(--secondary-two);
                outline: none;
            }

            h3 {
                margin-bottom: 10px;
                color: var(--var(--black));
                font-weight: 500;
            }
            .el-button.is-round {
                margin: 2px 3px 0px 2px;
            }
            .el-button.is-round:not(:first-child) {
                margin: 2px 3px 2px 2px;
            }
            .el-button.is-round {
                box-shadow: 0px 0px 2px 0px var(--block-shadow);
                border-radius: 20px;
                padding: 9px 20px;
                min-width: 149px;
                color: var(--primary);
            }
            .view-table {
                padding: 20px;
            }
        }

        .relatorio-rastreabilidade-container__button----active {
            border-color: var(--secondary-two) !important;
            color: var(--white) !important;
            background: var(--secondary-two) !important;
        }
    }
}
</style>
